import { z } from 'zod/v4';

import { placeSchema } from './place.schema';
import { siteSchema } from './site.schema';

export const placeDetailsSchema = placeSchema.extend({
  site: siteSchema,
  operatingHours: z.object({}).nullable(),
});

export type PlaceDetails = z.infer<typeof placeDetailsSchema>;
